import { useMutation, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { Notification } from 'types';

const markAllNotificationsRead = async (): Promise<{ message: string }> => {
  const { data } = await customAxios.patch<{ message: string }>(
    '/notifications/read-all'
  );
  return data;
};

export const useMarkAllNotificationsRead = () => {
  const queryClient = useQueryClient();

  return useMutation<{ message: string }, Error, void>({
    mutationFn: markAllNotificationsRead,
    onSuccess: () => {
      queryClient.setQueryData<Notification[]>(['notifications'], (old) => {
        if (!old) {
          return old;
        }
        const now = new Date().toISOString();
        return old.map((item) =>
          item.readAt ? item : { ...item, readAt: now }
        );
      });
    },
  });
};
